import React, { CSSProperties } from 'react';
import classnames from 'classnames';
import bemBlock from '@gik/core/utils/bemBlock';

export interface ILayoutAsideProps extends React.HTMLAttributes<HTMLDivElement> {
  asideWidth?: string;
  gutter?: string;
  breakpoint?: string;
  elementQueries?: boolean;
}

export default function LayoutAside({
  children,
  asideWidth,
  gutter,
  breakpoint,
  elementQueries,
  className,
  id,
}: ILayoutAsideProps): React.ReactElement {
  const bem = bemBlock(elementQueries ? 'layout-aside-eq' : 'layout-aside');
  const blockClasses = classnames([bem(), className || '']);
  const otherProps: Partial<ILayoutAsideProps> = {};
  if (elementQueries) {
    otherProps.style = {
      '--aside-width': asideWidth,
      '--gutter': gutter,
      '--breakpoint': breakpoint,
    } as CSSProperties;
  } else {
    otherProps.style = {
      '--aside-width': asideWidth,
      '--gutter': gutter,
    } as CSSProperties;
  }
  return (
    <div className={blockClasses} id={id} {...otherProps}>
      {children}
    </div>
  );
}
